import { Box } from "@hightouch/htui";
import type { AmpLibraryFileFragment } from "src/graphql";
import { SmsPreview } from "src/pages/lifecycle-studio/copy/components/preview/sms-preview";
import { IosPreview } from "src/pages/lifecycle-studio/copy/components/preview/push-preview";

export function MessageFilePreview({ file }: { file: AmpLibraryFileFragment }) {
  const message = file.message;
  if (!message) return null;
  if (file.type === "sms") {
    return <SmsPreview body={message.body ?? undefined} />;
  }
  if (file.type === "push") {
    return (
      <Box p={3} bg="white">
        <IosPreview
          title={message.title ?? undefined}
          body={message.body ?? undefined}
        />
      </Box>
    );
  }
  return null;
}
